var descriptors = ['L', 'M', 'N', 'S', 'BOOL'];

const flatten = o => {
    // flattens single property objects that have descriptors  
    Object.keys(o).forEach((k) => {
      for (let d of descriptors) {
        if (o[k].hasOwnProperty(d)) {
          o[k] = d === 'N' ?  parseFloat(o[k][d]) : o[k][d]
        }
      }
  
      if (Array.isArray(o[k])) {
        o[k] = o[k].map(e => {
          return flatten(e)
        })
      } else if (typeof o[k] === 'object') {
        o[k] = flatten(o[k])
      }
    })

    for (let d of descriptors) {
      if (o.hasOwnProperty(d)) {
        return d === 'N' ? parseFloat(o[d]) : o[d]
      }
    }
  
    return o
  }

export default flatten